import { ActionButtonsGroup } from "@shared/ui/ActionButtonsGroup";
import PanelTitle from "@shared/ui/PanelTitle";

export type Props = {
  onContinue: () => void;
};

export function FriendInvitationIntro({ onContinue }: Props) {
  return (
    <PanelTitle
      title="You're Almost Done!"
      description="Finish onboarding by inviting a friend to join your peer circle."
      className="flex-1"
      isInverted
    >
      <ActionButtonsGroup
        onPrimaryClick={onContinue}
        primaryButtonText={"Continue"}
        theme="dark"
      />
    </PanelTitle>
  );
}

export default FriendInvitationIntro;
